export default __webpack_public_path__ + "static/media/visaLogoNew.5b6d49f9.svg";